
import './BouquetAssemble.css';
import React, {useState} from "react";
import ribbons from '../assets/constants/ribbons.js';
import vases from '../assets/constants/vases.js';
import flowers from '../assets/constants/flowers.js';
import brickHeader from '../assets/images/brickHeader.png';
import VaseSelector from '../components/VaseSelector.js';
import RibbonSelector from '../components/RibbonSelector.js';
import leafCluster from '../assets/images/leafCluster.png';

function BouquetAssemble(props) {

    const [showRibbon, setShowRibbon] = useState(true)
    const [showVase, setShowVase] = useState(true)

    const positionMapping = [
        "back mid center",
        "back upper right",
        "back upper left",
        "back mid right",
        "back mid left",
        "middle bottom right",
        "middle bottom left",
        "front bottom center",
        "front middle right",
        "front middle left",
        "front bottom right",
        "front bottom left",
    ]

    function moveForwards(index) {
        if (index!==props.selectedFlowers.length-1) {
            let flowerArray = [...props.selectedFlowers]
            const swapValue = flowerArray[index]
            flowerArray[index]=flowerArray[index+1]
            flowerArray[index+1] = swapValue
            props.setSelectedFlowers(flowerArray)
        }
    }

    function moveBackwards(index) {
        if (index!==0) {
            let flowerArray = [...props.selectedFlowers]
            const swapValue = flowerArray[index]
            flowerArray[index]=flowerArray[index-1]
            flowerArray[index-1] = swapValue
            props.setSelectedFlowers(flowerArray)
        }
    }

    function removeFlower(index) {
        let flowerArray = [...props.selectedFlowers]
        flowerArray.splice(index, 1)
        props.setSelectedFlowers(flowerArray)
    }

    return (
        <div>
            <img src={brickHeader} alt="e-florals flower shop sign on a white brick building" className="brickHeaderimage"/>
                <div className="row">
                <div className="bouquetAssembleDisplay">
                    <div className="bouquetAssembleFlowerGroup">
                        <img className="bouquetShareleafClusterImage bouquetNoteLeaf" src={leafCluster} alt="green leaf cluster"/>
                        {props.selectedFlowers.map((flower, index) => (
                            <img key={index} className={"flowerImageLarge flowerImage" + index} src={flowers[flower].img} alt={flowers[flower].name} />
                        ))}
                    </div>
                    <img className="bouquetAssembleVase" src={vases[props.selectedDisplay].src} alt={vases[props.selectedDisplay].alt} />
                    <img className="bouquetAssembleVase bouquetAssembleVaseBack" src={vases[props.selectedDisplay].backSrc} alt={vases[props.selectedDisplay].alt} />
                    <div className={ribbons[props.selectedRibbon].outlineClass === "ribbon ribbonSmall" ? "bouquetAssembleRibbon bouquetAssembleRibbonSmall" : "bouquetAssembleRibbon"}>
                        <img className="chosenRibbonBouquetAssembly outlineRibbonChosen" src={ribbons[props.selectedRibbon].outlineSrc} alt="outline of a bow" />
                        <img className="chosenRibbonBouquetAssembly" src={ribbons[props.selectedRibbon].src} alt={ribbons[props.selectedRibbon].alt} />
                    </div>
                    <div className="changeSection">
                    <div className="changeSectionRibbon">
                        <p onClick={() => setShowRibbon(!showRibbon)} className="removeFlower changeSectionToggle"> {showRibbon? "hide" : "show"} ribbon selector</p>
                        {showRibbon &&
                            <div>
                                <RibbonSelector selectedRibbon={props.selectedRibbon} setSelectedRibbon={props.setSelectedRibbon}/>
                            </div>
                        }
                    </div>
                    <div className="changeSectionVase">
                        <p onClick={() => setShowVase(!showVase)} className="removeFlower changeSectionToggle">{showVase? "hide" : "show"} vase selector</p>
                        {showVase &&
                            <div>
                                <VaseSelector selectedDisplay={props.selectedDisplay} setSelectedDisplay={props.setSelectedDisplay}/>
                            </div>
                        }
                    </div>
                    </div>
                </div>
            <div className="rearrangeFlowerPanel" >
                <p onClick={() => props.setActiveStatus("write note")} className="navButton startWritingNoteButton"> start writing note </p>
                <p className="rearrangeFlowerText"> rearrange flowers </p>
                <div className="row flowerArrayGroup">
                        {props.selectedFlowers.map((flower, index) => (
                            <div key={index} className="flowersRectangleBox">
                                <img key={index} className="flowerArrayImage" src={flowers[flower].img} alt={flowers[flower].name} />
                                <p onClick={()=>removeFlower(index)} className="moveFlowerPositionText removeFlowerText"> remove </p>
                                <div className="row">
                                <p className="moveFlowerButton" onClick={()=>moveBackwards(index)}> &lt; </p>
                                <p className="moveFlowerButton" onClick={()=>moveForwards(index)}> &gt; </p>
                                </div>
                                <p className="moveFlowerPositionText"> {positionMapping[index]} </p>
                            </div>
                        ))}
                        {props.selectedFlowers.length<12 &&
                        <div>
                            <p className="moveFlowerPositionText backToFlowershopText"> you can add more flowers in the flower shop!</p>
                            <p className="moveFlowerPositionText backToFlowershopText buttonText" onClick={()=>props.setActiveStatus("flower shop")}> go to flower shop</p>
                            </div>
                        }
                    </div>
            </div>
            </div>
        </div>
    )
}

export default BouquetAssemble;